import { TableColumnItem, TableColumnTypeEnum } from '@ui-lib/components';

export const SERVICE_CENTERS_TABLE_COLUMNS: TableColumnItem[] = [
  {
    propName: 'name',
    captionTranslateKey: 'monitoring.service-centers.table.columns.name',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'address',
    captionTranslateKey: 'monitoring.service-centers.table.columns.address',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'contactInfo',
    captionTranslateKey: 'monitoring.service-centers.table.columns.contact-info',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'actions',
    captionTranslateKey: 'monitoring.service-centers.table.columns.actions',
    type: TableColumnTypeEnum.Actions,
  },
];
